import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-segmented-spinner',
  styleUrls: ['./segmented-spinner.component.scss'],
  templateUrl: './segmented-spinner.component.html',
})
export class SegmentedSpinnerComponent implements OnChanges {
  @Input() segmentsCount: number;
  @Input() completedSteps: number;
  segments: number[] = [];

  ngOnChanges() {
    this.segments = Array(this.segmentsCount || 10);
  }
}
